<div class="site" [routerLink]="site.seoSlug">
  <div class="image-header">
    @if (site.cardHeader) {
      <img [src]="site.cardHeader" alt="site banner" />
    } @else {
      @if (site && site.logoTitle && !site.logoURL) {
        <div>
          <img [src]="'/assets/img/logos/sites/icons/'+site.logoTitle+'.png'" />
        </div>
      }
      @if (site && headerImages[site.wpSlug]) {
        <div>
          <img [src]="headerImages[site.wpSlug]" />
        </div>
      }
      @if (site && !headerImages[site.wpSlug] && site.logoURL) {
        <div>
          <img [src]="site.logoURL"/>
        </div>
      }
    }
    <!-- Deprecate -->
  </div>
  <div class="content">
    <div>
      <div class="site-name">{{ site.name }}</div>
      <div class="site-audience">
        <div class="audience">{{ site.combinedAudience? site.combinedAudience : '-' }}</div>
        <div class="audience-label">Combined Audience</div>
      </div>
      <div class="site-description">
        <p>{{ site.description }}</p>
      </div>
    </div>
    <div>
      <!-- <a href="" class="details-button">Details</a> -->
      <a class="select-button" [routerLink]="site.seoSlug">Learn More</a>
    </div>
  </div>
</div>
